import { Deserializable } from '../interfaces';

export class RegisterUser implements Deserializable {
  Foto: File | '';
  idUsuarioValor: string;
  nombre: string;
  telefono: string;
  correoElectronico: string;
  idPais: string;
  contrasena: string;
  idUsuario: string;
  idioma: string;

  constructor() {
    this.Foto = '';
    this.idUsuarioValor = '0';
    this.nombre = '';
    this.telefono = '';
    this.correoElectronico = '';
    this.idPais = '';
    this.contrasena = '';
    this.idUsuario = '0';
    this.idioma = 'esp';
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
